import './TransshippingModal.scss';
import PropTypes from 'prop-types';
import { useState } from 'react';
import Error from '../../../../common/Error/Error';
import LoadingSpinner from '../../../../common/LoadingSpinner/LoadingSpinner';
import GoodsOut from '../../../../api/controllers/GoodsOut/GoodsOut';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWarning } from '@fortawesome/free-solid-svg-icons';
import Button from '../../../../common/Button/Button';

// General TransshippingModal Component
const TransshippingModal = ({
  category,
  movementId,
  setModalOpen,
  collection,
  refreshMovement,
  dangerousGoods,
}) => {
  const [error, setError] = useState();
  const [loading, setLoading] = useState();
  const [total, setTotal] = useState();

  const expType = collection?.assignments[0]?.job?.packageType?.name || 'Package';
  const expQuantity = collection?.assignments?.map(a => a?.quantity).reduce((a, b) => a + b, 0);
  const expWeight = collection?.assignments?.map(a => a?.grossWeightKg).reduce((a, b) => a + b, 0);
  const expVolume = Number(
    collection.assignments?.map(a => a?.cubicMetres).reduce((a, b) => a + b, 0),
  ).toFixed(2);

  const transshipMovement = () => {
    setLoading(true);
    const params = {
      goodsInType: collection.modelName,
      goodsInId: collection.id,
      quantity: total,
      category: category,
    };
    GoodsOut.transship(movementId, params)
      .then(() => {
        setLoading(false);
        refreshMovement();
        setModalOpen(false);
      })
      .catch(e => {
        setLoading(false);
        setError(e.errors || e.error);
      });
  };

  return (
    <div className="transshipping_container">
      {loading && <LoadingSpinner />}
      {error && (
        <Error
          errorMessages={error}
          type={'error'}
          errorTitle={
            Array.isArray(error)
              ? `${error.length} error${error.length > 1 ? 's' : ''} occurred: `
              : ''
          }
        />
      )}

      <Error
        errorMessages={
          'Warning: You are about to transship a collection directly on to this export vehicle'
        }
        type={'info'}
      />
      <div className="num_of_packages_container">
        <div className="block_label">Quantity</div>
        <input
          data-testid={'package_number_input'}
          className="number_of_packages"
          placeholder={`Default: ${expQuantity} ${expType}(s)`}
          type="number"
          value={total}
          onChange={e => setTotal(e.target.value)}
        />
      </div>
      <div className="transship_details">
        <ul>
          <li>
            The gross weight is <b>{expWeight} kg</b>
          </li>
          <li>
            The total volume is <b>{expVolume} m³</b>
          </li>
          <li>
            {dangerousGoods?.length > 0 ? (
              <li>
                The following dangerous goods are present (and are labelled correctly):
                <ul>
                  {dangerousGoods?.map(dangerousGood => (
                    <li key={dangerousGood.id}>
                      <div className={'dangerous_good'}>
                        {dangerousGood?.longText}:<b>{dangerousGood?.gross_weight_kg}kg</b>
                        <div className="job_line_symbol hazardous">
                          <FontAwesomeIcon icon={faWarning} data-testid="hazard_icon" />
                        </div>
                      </div>
                    </li>
                  ))}
                </ul>
              </li>
            ) : (
              <li>No Dangerous Goods present</li>
            )}
          </li>
          <li>
            The collection is <b>safe for export.</b>
          </li>
        </ul>
      </div>
      <div className="transshipping_buttons">
        <Button
          className="load_button"
          onClick={() => transshipMovement()}
          label="Confirm and load this collection"
        />
      </div>
    </div>
  );
};

TransshippingModal.propTypes = {
  category: PropTypes.string,
  movementId: PropTypes.number,
  setModalOpen: PropTypes.func,
  refreshMovement: PropTypes.func,
  collection: PropTypes.object,
  dangerousGoods: PropTypes.array,
};

export default TransshippingModal;
